<template>
   <div>
     <headers :tabIndex="1"></headers>
     <el-carousel height="13.34rem" class="banner-box">
       <el-carousel-item >
           <span class="homme-sp1" >四川交达预应力工程检测</span>
         <span class="homme-sp2">一家集检测服务、装备开发、科学研究和技术咨询业务为一体的专业预应力工程质量检测（监测）机构</span>
         <img class="img" src="@/assets/imgs/wap/2.png" />
       </el-carousel-item>
       <el-carousel-item >
         <span class="homme-sp1" >开启全数量检测新模式</span>
         <span class="homme-sp2" style="width: 5rem">中国最专业预应力工程全数字化技术服务平台，实现预应力检测及监测智能化、无人化、远程化、自动化4级进化</span>
         <img class="img" src="@/assets/imgs/wap/11.png" />
       </el-carousel-item>
       <el-carousel-item >
         <span class="homme-sp1">提升工程品质 杜绝安全隐患</span>
         <span class="homme-sp2">专注于预应力的研究实践，落实质量提升行动，引领行业持续、健康、高质量发展，创造更多、更大的价值</span>
         <img class="img" src="@/assets/imgs/wap/12.png" />
       </el-carousel-item>
     </el-carousel>

     <div ref="testref" :class="testShow?'title1':'title'">交达预应力 - 预应力品质工程践行者</div>

     <div class="home-content" ref="test2ref">
       <div class="li" :class="{'lis':testShow2}" >
         <div style="text-align: center;">
           <img class="img1" src="@/assets/imgs/home/1-1.png" />
           <span class="sp1">价值观</span>
           <span class="sp2">利他、专注、科技</span>
         </div>

       </div>
       <div  class="li" :class="{'lis':testShow2}" >
         <div style="text-align: center; ">
         <img class="img1" src="@/assets/imgs/home/1-2.png" />
         <span class="sp1">使命</span>
         <span class="sp2">提升工程品质，杜绝质量隐患</span>
         </div>
       </div>
       <div  class="li" :class="{'lis':testShow2}" >

         <div style="text-align: center;">
         <img class="img1" src="@/assets/imgs/home/1-3.png" />
         <span class="sp1">愿景</span>
         <span class="sp2">全数量检测的引领者</span>
         </div>
       </div>
     </div>

     <div class="detail-box" ref="test3ref">
       <div class="t2">
         四川交达在公路、铁路、市政、水利、矿山、地产等基建行业，对于广泛采用预应力技术的桥梁、边坡、隧道、基坑、巷道、建筑等重大基础设施工程结构，针对客户与合作伙伴（行政主管部门、建设单位、施工单位、监理单位等各方）在建设过程中长期面临的质量安全上的控制难、损失大、风险高、责任重等问题，为客户提供特色检（监）测、特殊试验、科研项目、产品研发、技术咨询、数据服务、技术培训等类型的相关业务。
       </div>
<!--       <span class="t1">四川交达</span>-->
<!--       <span class="t2" >四川交达预应力工程检测科技有限公司是一家在预应力工程领域内专业从事检测服务、装备开发、科学研究和技术咨询业务的高新科技企业。</span>-->
<!--       <span class="t1" >全数量检测新模式</span>-->
<!--       <span class="t2">四川交达致力于通过数字化技术重新定义预应力工程，开启全数量检测新模式，提供全新解决方案，带动工程检测升级换代和数字化转型，促进工程行业高质量发展。</span>-->
<!--       <span class="t1">产学研融政，坚持开放创新，打造专业生态</span>-->
<!--       <span class="t2">四川交达凝聚联合“双一流”高校、研究院所、行业龙头企业等顶尖团队与人才，融合产学研融政，坚持开放创新，打造专业生态，成就合作伙伴。公司以长期聚焦预应力工程检测细分领域的“专业化”技术积淀，以数据驱动工程质量管控向“精细化”发展，开启工程质量全数量无人化检测的“特色化”新模式，引领工程质量检测与管控的数字化转型迈向品质提升的“新颖化”发展之路。公司将始终秉持“专精特新”之道，为行业、客户、合作伙伴及员工提供值得信赖的全新解决方案与高质量服务，并共同引领行业持续、健康、高质量发展，创造更多、更大的价值。</span>-->
       <span class="t1">中国最专业的预应力工程</span>
       <span class="t1">全数字化技术服务平台</span>
     </div>


     <div class="detail-ul">
       <div class="detail-li">依托1套重大创新技术体系</div>
       <div class="detail-li">面向2大类预应力工程场景</div>
       <div class="detail-li">覆盖3大行业基建领域</div>
       <div class="detail-li">针对4类典型工程结构</div>
       <div class="detail-li">具有5种自主知识产权装备</div>
       <div class="detail-li">服务6方工程建设相关客户</div>
       <div class="detail-li">提供7项相关业务类型</div>
       <div class="detail-li" @click="goPage()">立即咨询</div>
     </div>


<!--     <div class="product-box">-->

<!--       <span class="h1" ref="test4ref">产品与服务</span>-->
<!--       <div style="display: -webkit-inline-box;overflow: auto;width: 100%;    margin: 0.4rem 0;">-->
<!--         <div class="product-box-li">-->
<!--           <img src="@/assets/imgs/product/1.png" />-->
<!--           <span class="li-span">预应力工程全数量检测系统-->
<!--               （PCS-UM20）</span>-->
<!--           <span class="li-span2">面向基建领域的预应力工程提供基于物联网智能感知、大数据分析决策、云平台智慧协同的数字化施工质量监测与管控解决方案。</span>-->
<!--         </div>-->
<!--         <div class="product-box-li">-->
<!--             <img src="@/assets/imgs/product/3.png" />-->
<!--           <span class="li-span">锚下预应力检测系统<br/>（PT-20S）</span>-->
<!--           <span class="li-span2">一种用于工后检测的锚下有效预应力检测设备。</span>-->
<!--         </div>-->
<!--         <div class="product-box-li">-->
<!--             <img src="@/assets/imgs/product/4.png" />-->
<!--           <span class="li-span" >-->
<!--           预应力锚索基础试验系统（PT-20C）-->
<!--         </span>-->
<!--           <span class="li-span2">一款经典的预应力锚索基础类试验系统。</span>-->
<!--         </div>-->
<!--         <div class="product-box-li">-->
<!--         <span class="li-span">-->
<!--           智能拉拔系统（PT-20M）-->
<!--         </span>-->
<!--           <span class="li-span2">一款先进的预应力锚索拉拔设备。</span>-->
<!--           <img src="@/assets/imgs/product/2.png"  />-->
<!--         </div>-->

<!--         <div class="product-box-li">-->
<!--             <img src="@/assets/imgs/product/5.png" />-->
<!--           <span class="li-span">-->
<!--          远程监测系统（JD-FAST21）-->
<!--         </span>-->
<!--           <span class="li-span2">一款通用化的岩土工程传感器远程采集传输设备。</span>-->
<!--         </div>-->
<!--       </div>-->

<!--     </div>-->

     <div class="technological-box6">
       <p class="box6-title">部分发明专利展示</p>
       <p class="box6-title2">公司申请专利</p>
       <p class="box6-title1">截至2022年7月</p>

       <p class="box6-title3">50<span style="font-size: 0.8rem">项</span></p>
       <p class="box6-line"></p>
       <div class="box6-box1 flex-sp ">
         <div class="box6-li">
           <p class="li6-1">发明专利</p>
           <p class="li6-2">25<span style="font-size: 0.6rem;">项</span></p>
         </div>
         <div class="box6-li">
           <p class="li6-1">实用新型</p>
           <p class="li6-2">20<span style="font-size: 0.6rem;">项</span></p>
         </div>
         <div class="box6-li">
           <p class="li6-1">软件著作</p>
           <p class="li6-2">5<span style="font-size: 0.6rem;">项</span></p>
         </div>
       </div>
       <el-carousel class="box-img" type="card" :interval="4000" :indicator-position="'none'" height="8.6rem">
         <el-carousel-item>
           <img src="@/assets/imgs/technological/9.png"/>
         </el-carousel-item>
         <el-carousel-item>
           <img src="@/assets/imgs/technological/10.png"/>
         </el-carousel-item>
         <el-carousel-item>
           <img src="@/assets/imgs/technological/11.png"/>
         </el-carousel-item>
         <el-carousel-item>
           <img src="@/assets/imgs/technological/12.png"/>
         </el-carousel-item>
         <el-carousel-item>
           <img src="@/assets/imgs/technological/1.jpg"/>
         </el-carousel-item>
         <el-carousel-item>
           <img src="@/assets/imgs/technological/2.jpg"/>
         </el-carousel-item>
         <el-carousel-item>
           <img src="@/assets/imgs/technological/3.jpg"/>
         </el-carousel-item>
         <el-carousel-item>
           <img src="@/assets/imgs/technological/4.jpg"/>
         </el-carousel-item>
         <el-carousel-item>
           <img src="@/assets/imgs/technological/5.jpg"/>
         </el-carousel-item>
         <el-carousel-item>
           <img src="@/assets/imgs/technological/18.png"/>
         </el-carousel-item>
         <el-carousel-item>
           <img src="@/assets/imgs/technological/19.png"/>
         </el-carousel-item>
         <el-carousel-item>
           <img src="@/assets/imgs/technological/5.jpg"/>
         </el-carousel-item>
       </el-carousel>
     </div>
     <div class="new-box">
       <div class="new-title">新闻快讯</div>
       <div class="new-header-img" @click="toPage(newList1)">
         <img :src="newList1.cover" style="width:100%;height:100%;object-fit: cover" />
         <div class="new-header-img-title">
           <p style="font-size: 0.3rem">{{newList1.title}}</p>
           <p style="margin-top:0.08rem">发布时间：{{newList1.publishDate}}</p>
         </div>
       </div>

       <div class="new-content">
         <div class="new-li flex" v-for="item in newList"  @click="toPage(item)">
           <div>
             <p class="time1">{{getTimeMo(item.publishDate)}}</p>
             <p class="time2">{{getTimeMo1(item.publishDate)}}</p>
           </div>
           <div style="margin-left: 0.4rem">
             <p class="new-span1">{{item.title}}</p>
             <p  class="new-span2">{{item.subTitle}}</p>
           </div>

         </div>
       </div>
     </div>

     <footers></footers>
   </div>
</template>

<script>
  import headers from "@/components/wap/header1"
  import footers from "@/components/wap/footer"
  import axios from "axios";
  export default {
    name: 'wapIndex',
    data(){
      return{
        testShow:false,
        testShow2:false,
        currentScroll:0,
        newList:[],
        newList1:{
          publishDate:"",
          title:"",
          cover:"",
        },
      }
    },
    mounted() {
      window.addEventListener('scroll', this.handleScrollbox, true);
      this.getNewsList()
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.handleScrollbox, true)
    },
    components:{headers,footers},
    methods:{

      //跳转立即咨询界面
      goPage(){
        this.$router.push(
          {
            name:"information"
          }
        )
      },
      getTimeMo(str){
        if(str){
          if(typeof str=="string"){
            str=str.replace(/-/g, '/');
          }
          let t1 = new Date(str)

          return t1.getDate()<10?('0'+t1.getDate()):t1.getDate()
        }

        return ""
      },

      getTimeMo1(str){
        if(str){
          if(typeof str=="string"){
            str=str.replace(/-/g, '/');
          }
          let t1 = new Date(str)
          return t1.getFullYear()+"."+((t1.getMonth()+1)<10?('0'+(t1.getMonth()+1)):(t1.getMonth()+1))
        }

        return ""
      },
      getNewsList(){
        axios.get(this.pageUrl+`/news/page?pageNo=1&pageSize=6`).then(res=>{
          this.newList1=res.data.data.list[0];
          this.newList = res.data.data.list.slice(1,res.data.data.list.length);
        })
      },
      toPage(data){
        if(data.type=='outer'){
          window.open(data.url)
        }else if(data.type=='inner'){
          this.$router.push({
            path:'/newsDetail',
            query:{
              id:data.id
            }
          })
        }
      },
      handleScrollbox() {
        this.currentScroll = window.pageYOffset //表示当前滚动的位置
        if(this.$refs.testref){
          if (this.currentScroll >= this.$refs.testref.offsetTop - 700) {
            //当前滚动位置到达testref的时候，显示div（100作为调整用）
            this.testShow = true
          }
        }
        if(this.$refs.test2ref){
          if (this.currentScroll >= this.$refs.test2ref.offsetTop - 600) {
            this.testShow2 = true
          }
        }
      },
    }
  }
</script>

<style>
  .technological-box6 .el-carousel__item--card.is-active {
    transform: translateX(5%) scale(1) !important;
    width: 90%;
  }
</style>

<style scoped>

  .detail-ul{
    display: grid;
    grid-template-columns: repeat(2,3.4rem);
    grid-template-rows: repeat(4,1.2rem);
    grid-gap: 0.2rem;
    margin-top: 0.7rem;
    width: 100%;
    padding: 0 0 0 0.25rem;
    box-sizing: border-box;
  }

  .detail-ul .detail-li{
    background-color: #0071EF;
    border-radius: 0.06rem;
    display: flex;
    justify-content: center;
    color: #FFFFFF;
    font-size: 0.28rem;
    align-items: center;
    text-align: center;
  }

  .technological-box6 {
    padding-bottom: 0.66rem;
    margin-top: 0.6rem;
  }

  .technological-box6 .box6-title {
    font-size: 0.36rem;
    text-align: center;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    color: #19203B;
  }

  .technological-box6 .box6-title2 {
    font-size: 0.36rem;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    color: #0071EF;
    text-align: center;
    margin-top: 0.6rem;
  }

  .technological-box6 .box6-title1 {
    font-size: 0.28rem;
    text-align: center;
    margin-top: 0.1rem;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #5C5D5F;
  }

  .technological-box6 .box6-title3 {
    font-size: 1.6rem;
    font-family: DIN Alternate-Bold, DIN Alternate;
    font-weight: bold;
    color: #0071EF;
    text-align: center;
  }

  .technological-box6 .box6-line {
    width: 6.04rem;
    height: 0.02rem;
    background: #5C5D5F;
    margin: 0.4rem auto;
  }

  .technological-box6 .box6-li {
    font-size: 0.36rem;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    color: #19203B;
  }

  .technological-box6 .box6-box1 {
    padding: 0 0.4rem;
    width: 100%;
    box-sizing: border-box;
  }

  .technological-box6 .li6-2 {
    font-size: 0.8rem;
    font-family: DIN Alternate-Bold, DIN Alternate;
    font-weight: bold;
    color: #19203B;
  }

  .technological-box6 .box-img {
    margin-top: 0.4rem;
  }

  .technological-box6 .box-img img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  .banner-box{
    position: relative;
  }
  .banner-box .img{
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    object-fit: cover;
    z-index: 0;
  }
  .banner-box .homme-sp1{
    position: absolute;
    top: 3rem;
    left: 0.68rem;
    opacity: 0;
    margin: 0 auto;
    font-size: 0.48rem;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: rgba(25, 32, 59, 1);
    right: 0;
    animation-name: fadeInUp;
    animation-duration:1s;
    animation-timing-function:ease;
    animation-fill-mode:forwards;
    z-index: 2;
  }
 .title{
    font-size: 0.36rem;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #19203B;
    opacity: 0;
  }
  .title1{
    font-size: 0.36rem;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #19203B;
    opacity: 0;
    margin-top: .32rem;
    animation-name: fadeInUp;
    animation-duration:1s;
    animation-timing-function:ease;
    display: block;
    animation-fill-mode:forwards;
    text-align: center;
  }
  .banner-box .homme-sp2{
    position: absolute;
    top: 4rem;
    left: 0.68rem;
    right: 0;
    animation-name: fadeInUp;
    animation-duration:1s;
    animation-delay: 1s;
    animation-timing-function:ease;
    animation-fill-mode:forwards;
    opacity: 0;
    z-index: 2;
    font-size: 0.28rem;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: rgba(25, 32, 59, 1);
    width: 5.36rem;
    line-height: 2.4;
  }

  .home-content{
    margin-top: 0.32rem;
  }
  .home-content .li{
    width: 6.04rem;
    height: 3.4rem;
    background: #F1F3F9;
    border-radius:0.08rem;
    opacity: 0;
    margin: 0 auto;
    margin-bottom: 0.2rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .home-content .lis{
    animation-name: fadeInUp;
    animation-duration:1s;
    animation-timing-function:ease;
    animation-fill-mode:forwards;
  }

  .home-content .li img{
    width: 1.2rem;
    height: 1.2rem;
  }
  .home-content .li .sp1{
    font-size: 0.32rem ;
    display: block;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    text-align: center;
    color: #19203B;
  }
  .home-content .li .sp2{
    font-size: 0.28rem;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    text-align: center;
    color: #808080;
    margin-top: 0.1rem;
    display: block;
  }

  .detail-box{
    padding: 0 .72rem;
    width: 100%;
    box-sizing: border-box;
    margin-top: 0.6rem;
  }
  .detail-box .t1{
    font-size: 0.32rem;
    display: block;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #19203B;
    margin-bottom: 0.2rem;
    text-align: center;
  }
  .detail-box .t2{
    font-size: 0.28rem;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #5C5D5F;
    display: block;
    margin-bottom: 0.4rem;
    line-height: 1.8;
  }

  .map-box{
    background-color: #F1F3F9;
    padding: 0.4rem 0.72rem;
    width: 100%;
    box-sizing: border-box;
  }
  .map-box .map-box-li{
    font-size: 0.48rem;
    font-family: Titillium Web-Bold, Titillium Web;
    font-weight: bold;
    margin-bottom: 0.4rem;
  }
  .map-box .map-box-li p{
    font-size: 0.28rem;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #5C5D5F;
    margin-top: 0.2rem;
  }

  .product-box{
    width: 100%;
    text-align: center;
    background: #F1F3F9;
  }
  .product-box .h1{
    font-size: 0.32rem;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    color: #19203B;
    text-align: center;
  }

  .product-box .product-box-li{
    width: 5.4rem;
    height: 7.2rem;
    background: #181C25;
    border-radius: 0.08rem;
    margin: 0 0.2rem;
    opacity: 1;
    position: relative;
  }
  .product-box .product-box-li img{
    width: 80%;
    position: absolute;
    left: 0;
    right: 0;
    margin: 0 auto;
    bottom: 0;
    z-index: 1;
  }
  .product-box .product-box-li .li-span{
    font-size: 0.32rem;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    display: block;
    color: #FFFFFF;
    position: relative;
    z-index: 2;
    width: 60%;
    margin: 0.4rem auto;
  }
  .product-box .product-box-li .li-span2{
    font-size: 0.28rem;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    display: block;
    position: relative;
    z-index: 2;
    width: 90%;
    margin: 0.4rem auto;
  }


  .new-box{
    background-color: #FFFFFF;
    padding-top: .6rem;
  }

  .new-box .new-title{
    font-size: 0.32rem;
    text-align: center;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    color: #19203B;
    margin-bottom: 0.4rem;
  }
  .new-box .new-header-img{
    width: 6rem;
    margin: 0 auto;
    height: 4.4rem;
    position: relative;
  }
  .new-header-img-title{
    background: rgb(255 255 255 / 20%);
    position: absolute;
    bottom: 0;
    font-size: 0.24rem;
    padding: 0.2rem;
    width: 100%;
    color: #ffffff;
  }
  .new-content{
    width: 6.08rem;
    margin: 0.2rem auto 0.8rem;
  }
  .new-content .new-li{
    margin-bottom: 0.2rem;
    align-items: center;
    border-radius: 0.08rem;
    background: #F1F3F9;
    padding: 0.2rem 0.3rem;
  }
  .new-content .new-li .time1{
    font-size: 0.8rem;
    font-family: Titillium Web-Bold, Titillium Web;
    font-weight: bold;
    color: #0071EF;
    display: block;
    line-height: 1;
  }
  .new-content .new-li .time2{
    font-size: 0.24rem;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #5C5D5F;
    margin-top: 0.05rem;
  }
  .new-content .new-span1{
       font-size: 0.3rem;
       font-family: PingFang SC-Bold, PingFang SC;
       font-weight: bold;
    width: 4.24rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
       color: #19203B;
     }
  .new-content .new-span2{
    font-size: 0.3rem;
    font-family: PingFang SC-Bold, PingFang SC;
    color: rgba(92, 93, 95, 1);
    width: 4.24rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-top: 0.2rem;
  }
</style>



// WEBPACK FOOTER //
// src/view/wapIndex.vue